<template>
  <el-dialog
    title="选择会员"
    :visible.sync="show"
    width="60%"
    top="5vh"
    :before-close="handleClose"
  >
    <RegionList
      @change="handleChange"
      :defaultData="defaultData"
      :show="show"
    />
    <span slot="footer">
    <el-button @click="handleClose" >取 消</el-button>
    <el-button @click="handleClose" type="primary">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
import RegionList from "./regionList";
export default {
  name: "index",
  components: {
    RegionList,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    defaultData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    handleChange(e) {
      this.$emit("change", e);
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped></style>
